const routes = [
    {
        path: "/",
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/pages/home/index'),
        children: [
            {
                path: 'solution',
                name: 'solution',
                component: () => import('@/pages/home/solution')
            },
            {
                path: 'product',
                name: 'product',
                component: () => import('@/pages/home/product')
            },
            {
                path: 'culture',
                name: 'culture',
                component: () => import('@/pages/home/culture')
            }
        ]
    },
    {
        path: '/solve',
        name: 'solve',
        component: () => import('@/pages/solve')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('@/pages/product')
    },
    {
        path: '/case',
        name: 'case',
        component: () => import('@/pages/case')
    },
    {
        path: '/innovate',
        name: 'innovate',
        // component: () => import('@/pages/innovate')
        component: () => import('@/pages/point')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/pages/about')
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('@/pages/test')
    },
    {
        path: '/detail',
        name: 'detail',
        component: () => import('@/pages/detail')
    },
    {
        path: '/solution',
        name: 'solution',
        component: () => import('@/pages/solution')
    }
]

// 加路由守卫 跳转前将滚动条置顶
routes.forEach(route => {
    route.beforeEnter = (to, from, next) => {
        window.scrollTo(0, 0)
        next()
    }
})


export default routes